import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';
import { paletteSearchKey } from '@dashboard/lib/queryKeys';

export interface PaletteResultRow {
  id: string;
  label: string;
  subtitle?: string;
  path: string;
  pageType?: string;
}

interface Config<TRow> {
  groupKey: string;
  buildPath: (sellerId: string, query: string) => string;
  mapResult: (row: TRow) => PaletteResultRow;
}

export function createPaletteSearchHook<TRow = unknown>(config: Config<TRow>) {
  return function usePaletteSearch(query: string) {
    const { token, sellerId } = useAuth();
    const enabled = query.length >= 2 && Boolean(token) && Boolean(sellerId);

    const q = useQuery<PaletteResultRow[]>({
      queryKey: paletteSearchKey(config.groupKey, sellerId, query),
      queryFn: async () => {
        const rows = (await fetcher(config.buildPath(sellerId, query), token)) as TRow[];
        return (rows || []).map(config.mapResult);
      },
      enabled,
      staleTime: 30_000,
    });

    return {
      ...q,
      data: q.data ?? [],
    };
  };
}
